import { CouponDefaultErrorsInterface } from '../types/default-errors-interface'

export const couponDefaultErrors: CouponDefaultErrorsInterface = {
  coupons: '',
  common: '',
}
